module.exports = __webpack_public_path__ + "img/invigorate-multiple-movie.1eb2095d.png";